import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import EventCard from "@/components/EventCard";
import { useApp } from "@/context/AppContext";

export default function OrganizerProfile() {
  const { user_id } = useParams();
  const { t } = useApp();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/organizers/${user_id}`).then(r => setData(r.data)); }, [user_id]);
  if (!data) return <div className="p-8">Loading…</div>;
  return (
    <div className="max-w-6xl mx-auto px-4 md:px-6 py-8">
      <Link to="/" className="eyebrow hover:underline">← {t("home")}</Link>
      <h1 className="mt-3 font-display uppercase text-4xl md:text-5xl tracking-tighter">{data.user.name}</h1>
      {data.profile?.short_description && <p className="mt-2 text-lg">{data.profile.short_description}</p>}
      <div className="mt-4 flex flex-wrap gap-3 text-sm">
        {data.profile?.website && <a className="underline" href={data.profile.website} target="_blank" rel="noreferrer">{t("website")}</a>}
        {data.profile?.facebook && <a className="underline" href={data.profile.facebook} target="_blank" rel="noreferrer">Facebook</a>}
        {data.profile?.instagram && <a className="underline" href={data.profile.instagram} target="_blank" rel="noreferrer">Instagram</a>}
      </div>
      <h2 className="mt-10 font-display uppercase text-2xl border-b border-foreground pb-2">{t("upcoming")}</h2>
      <div className="mt-6 grid grid-cols-1 xl:grid-cols-2 gap-3 md:gap-4">
        {data.events.map(e => <EventCard key={e.event_id} event={e} />)}
        {!data.events.length && <div className="col-span-full eyebrow text-center py-8">—</div>}
      </div>
    </div>
  );
}
